//import Prescription from './screens/index.vue';
const Prescription = () => import('./screens/index.vue')

const PatientsPrescrMonitoringyTable = () => import('../dashboard/patient-prescr-monitoring-table.vue')
export const PATIENTS_MONITORING_PATH = '/pacientes/prescricoes/acompanhamento';

//import Transcription from './screens/transcription.vue';
const Transcription = () => import('./screens/transcription.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';
import { ACCESS_TYPE_EMEDE } from '@/settings/consts/users';
import { getLocalUser } from '@/services/session-data';

const prescriptionRoutes = [];
const PRESCRIPTION_PATH = '/prescricao';
export const PRESCRIPTION_COPY_PATH = '/prescricoes/cp';
const TRANSCRIPTION_PATH = '/prescricao/transcricao';
const hasPrescriptionPermission = () => {
  return checkUserPermissions([
    PERMISSIONS_KEYS.PRESCRIPTION_VIEW,
    PERMISSIONS_KEYS.PRESCRIPTION_INSERT,
    PERMISSIONS_KEYS.PRESCRIPTION_EDIT,
    PERMISSIONS_KEYS.PRESCRIPTION_APPROVE,
    PERMISSIONS_KEYS.PRESCRIPTION_CLIENT_APPROVE,
  ]);
};
const hasTranscriptionPermission = () => {
  return checkUserPermissions([
    PERMISSIONS_KEYS.TRANSCRIPTION_VIEW,
    PERMISSIONS_KEYS.TRANSCRIPTION_INSERT,
    PERMISSIONS_KEYS.TRANSCRIPTION_EDIT,
    PERMISSIONS_KEYS.TRANSCRIPTION_APPROVE,
  ]);
};

if (hasPrescriptionPermission()) {
  prescriptionRoutes.push({
    path: PRESCRIPTION_PATH,
    name: 'Cadastro / Consulta|Prescrição',
    component: Prescription,
    meta: {
      icon: 'fa-clipboard-list',
      requiresAuth: true,
    },
  });
  prescriptionRoutes.push({
    path: '/prescricoes/cp',
    name: 'Cadastro / Consulta|Prescrição - Copiar',
    component: Prescription,
    meta: {
      requiresAuth: true,
      hideFromMenu: true
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.MONITORING_PATIENT
  ])
) {
  getLocalUser().subscribe(res => {
    if (res.tipoAcesso === ACCESS_TYPE_EMEDE){
        return
    }
    prescriptionRoutes.push({
        path: PATIENTS_MONITORING_PATH,
        name: 'Cadastro / Consulta|Acompanhamento de Paciente',
        component: PatientsPrescrMonitoringyTable,
        meta: {
            icon: 'fa-bar-chart',
            requiresAuth: true,
        },
    });
  });
}

if (hasTranscriptionPermission()) {
  prescriptionRoutes.push({
    path: TRANSCRIPTION_PATH,
    name: 'Cadastro / Consulta|Transcrição',
    component: Transcription,
    meta: {
      icon: 'fa-clipboard-list',
      requiresAuth: true,
    },
  });
}

export {
  prescriptionRoutes,
  PRESCRIPTION_PATH,
  TRANSCRIPTION_PATH,
  hasPrescriptionPermission,
  hasTranscriptionPermission,
};
